import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import { shouldShowFullJump, showFullJumpPage } from '@/utils/wechat-jump'

// 关闭生产环境提示
Vue.config.productionTip = false

// 使用Vant UI组件库
Vue.use(Vant)

// 微信内打开的所有页面（/ 与 /mp 等）在 Vue 挂载前直接接管整页，引导跳转小程序：
// - 不再依赖拦截 window.location.replace（微信 iOS 内核该属性只读，覆盖会白屏）
// - 由 showFullJumpPage 同步渲染跳转层，杜绝 OAuth 抢跑与白屏
if (shouldShowFullJump()) {
  // 微信内不挂载 Vue：页面自身 OAuth 跳转根本不会触发，
  // 整页由静态跳转层接管，杜绝白屏与 OAuth 抢跑
  showFullJumpPage()
} else {
  // 创建Vue实例并挂载
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
